var _mask, _path, _path2, _path3, _path4, _rect, _rect2, _path5, _path6, _path7, _rect3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMarker(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-1-outside-1",
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 22,
    height: 22,
    fill: "black"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "white",
    width: 22,
    height: 22
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4 1C2.89543 1 2 1.89543 2 3V6C1.44772 6 1 6.44772 1 7V11C1 11.5523 1.44772 12 2 12V18V19C2 20.1046 2.89543 21 4 21C5.10457 21 6 20.1046 6 19H16C16 20.1046 16.8954 21 18 21C19.1046 21 20 20.1046 20 19V18V12C20.5523 12 21 11.5523 21 11V7C21 6.44772 20.5523 6 20 6V3C20 1.89543 19.1046 1 18 1H4Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4 1C2.89543 1 2 1.89543 2 3V6C1.44772 6 1 6.44772 1 7V11C1 11.5523 1.44772 12 2 12V18V19C2 20.1046 2.89543 21 4 21C5.10457 21 6 20.1046 6 19H16C16 20.1046 16.8954 21 18 21C19.1046 21 20 20.1046 20 19V18V12C20.5523 12 21 11.5523 21 11V7C21 6.44772 20.5523 6 20 6V3C20 1.89543 19.1046 1 18 1H4Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2 6V7H3V6H2ZM2 12H3V11H2V12ZM6 19V18H5V19H6ZM16 19H17V18H16V19ZM20 12V11H19V12H20ZM20 6H19V7H20V6ZM3 3C3 2.44772 3.44772 2 4 2V0C2.34315 0 1 1.34315 1 3H3ZM3 6V3H1V6H3ZM2 7V5C0.89543 5 0 5.89543 0 7H2ZM2 11V7H0V11H2ZM2 11H0C0 12.1046 0.89543 13 2 13V11ZM3 18V12H1V18H3ZM1 18V19H3V18H1ZM1 19C1 20.6569 2.34315 22 4 22V20C3.44772 20 3 19.5523 3 19H1ZM4 22C5.65685 22 7 20.6569 7 19H5C5 19.5523 4.55228 20 4 20V22ZM16 18H6V20H16V18ZM15 19C15 20.6569 16.3431 22 18 22V20C17.4477 20 17 19.5523 17 19H15ZM18 22C19.6569 22 21 20.6569 21 19H19C19 19.5523 18.5523 20 18 20V22ZM21 19V18H19V19H21ZM19 12V18H21V12H19ZM20 11V13C21.1046 13 22 12.1046 22 11H20ZM20 7V11H22V7H20ZM20 7H22C22 5.89543 21.1046 5 20 5V7ZM19 3V6H21V3H19ZM18 2C18.5523 2 19 2.44772 19 3H21C21 1.34315 19.6569 0 18 0V2ZM4 2H18V0H4V2Z",
    fill: "#C5C5C5",
    mask: "url(#path-1-outside-1)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2 18H6V19C6 20.1046 5.10457 21 4 21C2.89543 21 2 20.1046 2 19V18Z",
    fill: "#161616"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16 18H20V19C20 20.1046 19.1046 21 18 21C16.8954 21 16 20.1046 16 19V18Z",
    fill: "#161616"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 15,
    width: 18,
    height: 2,
    fill: "#FFD82E"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 17,
    width: 18,
    height: 2,
    fill: "#127EF1"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M3 6H19V11C19 12.6569 17.6569 14 16 14H6C4.34315 14 3 12.6569 3 11V6Z",
    fill: "#767676"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M4.5 16C4.77614 16 5 16.2239 5 16.5C5 16.7761 4.77614 17 4.5 17H2V16H4.5Z",
    fill: "#CACACA"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M20 16V17H17.5C17.2239 17 17 16.7761 17 16.5C17 16.2239 17.2239 16 17.5 16H20Z",
    fill: "#CACACA"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 13.5,
    y: 3.5,
    width: 5,
    height: 1,
    rx: 0.5,
    transform: "rotate(90 13.5 3.5)",
    fill: "#CACACA"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarker);
export default __webpack_public_path__ + "static/media/marker.c82601df18d6616f2babb4a6f410842f.svg";
export { ForwardRef as ReactComponent };